import type { ReactNode } from 'react';

import { TooltipsEnabledProvider } from '~/components/ui/tip';
import { useUiPreferences } from '~/hooks/queries/use-ui-preferences';

/**
 * FRONT-2267: feeds the person's tooltips on/off switch to the `Tooltip`
 * primitive, mounted once at the app root outside Radix's `TooltipProvider`.
 *
 * The query lives here rather than in `components/ui/tooltip.tsx` so that
 * file stays a UI primitive with no data dependency — and so this is the
 * single place the fallback is decided. Anything other than a definite
 * `false` (still loading, request failed, signed out) means tooltips stay ON:
 * a person who never touched the switch must not lose them because a request
 * was slow.
 */
export function TooltipsPreferenceProvider({ children }: { children: ReactNode }) {
  const { data } = useUiPreferences();
  return (
    <TooltipsEnabledProvider enabled={data?.tooltipsEnabled ?? true}>
      {children}
    </TooltipsEnabledProvider>
  );
}
